import React from 'react';
import { useParams } from 'react-router-dom';
import { getSetupData } from 'additiv-services/setup';
import { ApplicationList } from './components/OverviewApplications/ApplicationList';
import ProposalOverview from './components/ProposalOverview';
import Overview from './components/Overview';
import Portfolios from '../Portfolios/Portfolios';
import { ClientDashboardProvider } from './context';
import './Dashboard.css';

const setupData = getSetupData();

const Dashboard = () => {
    const { dfsClientId } = useParams();

    return (
        <ClientDashboardProvider {...{ dfsClientId: dfsClientId as string }}>
            <div className="container">
                <div className="fi-verticals">
                    <Overview />
                    <Portfolios dfsClientId={dfsClientId as string} />
                    <ApplicationList />
                    {setupData?.PRODUCT_PROPOSAL_FEATURE_FLAG && (
                        <ProposalOverview />
                    )}
                </div>
            </div>
        </ClientDashboardProvider>
    );
};

export default Dashboard;
